var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hv-video"},[(_vm.data.mode == 'popup')?[_c('BaseImage',{attrs:{"data":{ img: _vm.data.playerOptions.poster, video: _vm.data.playerOptions.src }}})]:[_c('VideoItem',_vm._g({attrs:{"data":_vm.data}},_vm.$listeners))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }